import React from 'react';
import PageHeaderSection from 'app/components/misc/PageHeaderSection';
import { RichText } from 'prismic-reactjs';
import GoogleMap from './GoogleMap';
import * as S from './styles';

const AboutContent = ({ doc }) => {
  const investorsGallery = doc.investorsImg.map((investor, index) => {
    return <S.Investor key={index} src={investor.image.url} />;
  });

  return (
    <>
      <PageHeaderSection
        title="About Seedly"
        subtitle="At Seedly, we help you make smarter financial decisions with the right tools and the right mindset"
      />
      <S.PageContent>
        <S.Text>{RichText.render(doc.intro)}</S.Text>
        <S.Investors>{investorsGallery}</S.Investors>
        <S.Text style={{ textAlign: 'center' }}>
          {RichText.render(doc.joinUs)}
        </S.Text>
        <GoogleMap />
      </S.PageContent>
    </>
  );
};

export default AboutContent;
